/**
 * EventColorStripe primitive (Plan 03-06).
 *
 * Phase 3 D-05: 4-px coloured stripe along the left edge of an EventCard.
 * Slot resolves server-side via resolveEventColor (see packages/shared).
 * Member slots map directly to Tailwind v4 `bg-m-<slot>` utilities.
 * The fallback `ochre` maps to the design-system ochre fallback.
 *
 * The stripe is purely decorative — `aria-hidden="true"` on the element.
 */

export type ColorStripeSlot =
  | 'm-terracotta'
  | 'm-berry'
  | 'm-ochre'
  | 'm-sage'
  | 'm-sky'
  | 'm-plum'
  | 'ochre';

/** Fyllet per slot; også prikkene i kalenderens ukestripe (#157). */
export const STRIPE_BG: Record<ColorStripeSlot, string> = {
  'm-terracotta': 'bg-m-terracotta',
  'm-berry': 'bg-m-berry',
  'm-ochre': 'bg-m-ochre',
  'm-sage': 'bg-m-sage',
  'm-sky': 'bg-m-sky',
  'm-plum': 'bg-m-plum',
  'ochre': 'bg-warn',
};

/**
 * `color_token` fra API-et som ColorStripeSlot; en ukjent verdi blir `ochre`.
 * Flyttet hit fra EventCard (#154), så Hjem og kalenderen deler den.
 */
export function resolveStripeSlot(colorToken: string): ColorStripeSlot {
  return Object.hasOwn(STRIPE_BG, colorToken) ? (colorToken as ColorStripeSlot) : 'ochre';
}

interface EventColorStripeProps {
  slot: ColorStripeSlot;
}

export function EventColorStripe({ slot }: EventColorStripeProps) {
  const cls = STRIPE_BG[slot] ?? STRIPE_BG['ochre'];
  return (
    <div
      aria-hidden="true"
      data-testid={`event-stripe-${slot}`}
      className={`w-1 shrink-0 self-stretch ${cls} rounded-l-[inherit]`}
    />
  );
}
